import { useGetWeaveEnhancedInsuranceVerificationCustomizationFlagDetails } from '@frontend/insurance-verification';

export const useShouldEnableZipCode = (payerId: string, locationId: string) => {
  const { locationIdWiseCustomizationFlagDetails } = useGetWeaveEnhancedInsuranceVerificationCustomizationFlagDetails();
  if (!locationId || !payerId) return false;
  const isEnhancedInsuranceVerificationEnabled = locationIdWiseCustomizationFlagDetails?.[locationId!] || false;
  const isMetlifePayerSelected = payerId?.toLowerCase().includes('metlife');
  return isEnhancedInsuranceVerificationEnabled && isMetlifePayerSelected;
};
